module.exports = __webpack_public_path__ + "static/media/people.f7a89791.svg";